import React, { ReactNode } from 'react'
import { cn } from 'src/lib/utils'

interface SeriesCardOverlayProps {
  children: ReactNode
  className?: string
}

export const SeriesCardOverlay = ({ children, className }: SeriesCardOverlayProps): React.ReactElement => {
  return (
    <div
      className={cn(
        'absolute inset-0 flex flex-col justify-between',
        'bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.6)_100%)]',
        className,
      )}
    >
      {children}
    </div>
  )
}
